import { getGlobalClassNames, HighContrastSelector } from '@uifabric/styling';
var GlobalClassNames = {
    root: 'ms-Card'
};
var baseTokens = function (props, theme) {
    var effects = theme.effects;
    return {
        boxShadow: effects.elevation4,
        childrenGap: 12,
        childrenMargin: 0,
        cursor: 'default',
        height: 'inherit',
        highContrastBoxShadow: '0 1.6px 3.6px 0 Highlight, 0 0.3px 0.9px 0 Highlight',
        minHeight: '348px',
        minWidth: '212px',
        maxWidth: '286px'
    };
};
var compactTokens = {
    height: 'auto',
    minWidth: '300px',
    maxWidth: '500px'
};
var clickableTokens = function (props, theme) {
    var effects = theme.effects;
    return {
        boxShadowHovered: effects.elevation8,
        cursor: 'pointer',
        highContrastBoxShadowHovered: '0 3.2px 7.2px 0 Highlight, 0 0.6px 1.8px 0 Highlight'
    };
};
export var CardTokens = function (props, theme) { return [
    baseTokens,
    props.compact && compactTokens,
    props.onClick && clickableTokens
]; };
export var CardStyles = function (props, theme, tokens) {
    var _a, _b;
    var classNames = getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                borderRadius: '2px',
                boxShadow: tokens.boxShadow,
                cursor: tokens.cursor,
                height: tokens.height,
                width: tokens.width,
                minWidth: tokens.minWidth,
                maxWidth: tokens.maxWidth,
                transition: 'box-shadow 0.5s ease',
                selectors: (_a = {
                        ':hover': {
                            boxShadow: tokens.boxShadowHovered,
                            selectors: (_b = {},
                                _b[HighContrastSelector] = {
                                    boxShadow: tokens.highContrastBoxShadowHovered
                                },
                                _b)
                        }
                    },
                    _a[HighContrastSelector] = {
                        boxShadow: tokens.highContrastBoxShadow
                    },
                    _a)
            }
        ]
    };
};
//# sourceMappingURL=Card.styles.js.map